var helper = {
  formatDesc(str) {
    if (str.charAt(0) === '"') {
      str = str.substr(1, str.length - 1);
    }
    if (str.charAt(str.length - 1) === '"') {
      str = str.substr(0, str.length - 2);
    }
    return str.replace(/(?:\\[rn])+/g, "<br>");
  }
};

export default helper;



// WEBPACK FOOTER //
// ./src/helper.js